import axios from "axios";
import keycloak from "../store/modules/auth/keycloak";
import { API_BASE_URL } from "../env.js";

export default new (class Config {
  constructor() {
    this.axios = null;
    this._token = null;
  }

  async setup() {
    this._token = keycloak.token;
    this.axios = axios.create({
      baseURL:
        process.env.NODE_ENV === "production"
          ? API_BASE_URL
          : `${process.env.VUE_APP_API_BASE_URL}`,
      headers: {},
    });

    this.axios.interceptors.request.use(function (config) {
      setToken(config, keycloak.token);
      return config;
    });
    this.axios.interceptors.response.use(
      function (response) {
        return response;
      },
      function (error) {
        return error.response;
      }
    );
  }
})();

function setToken(config, token) {
  config.headers["Authorization"] = `Bearer ${token}`;
}
